import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import type { Option } from 'modules/core/components/Popover/Content'
import PopoverMenu from 'modules/core/components/PopoverMenu'

interface Props {
  label: string
  subtitle: string
  popoverOptions: Option[]
}

const AllowanceItem = ({ label, subtitle, popoverOptions }: Props) => {
  return (
    <Box
      alignItems="center"
      flexDirection="row"
      flexGrow
      justifyContent="spaceBetween"
      paddingX="s32"
      paddingY="s24"
    >
      <Box width="s240">
        <Text.Header2>{label}</Text.Header2>
        <Text.Normal color="grey600">{subtitle}</Text.Normal>
      </Box>
      <PopoverMenu type="list">
        <PopoverMenu.Trigger extra={{ 'data-intercom-target': 'timeoff-allowances-list-item' }}>
          <Button type="secondary" iconName="settings" />
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {popoverOptions.map((option, index) => {
            return (
              <PopoverMenu.TouchableOption
                key={index}
                onClick={option.onClick}
                title={option.title || ''}
                extra={{ 'data-intercom-target': 'timeoff-allowances-list-item-option' }}
              />
            )
          })}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}

export default AllowanceItem
